import { Button, Form } from 'antd';
import React, { useEffect } from 'react';

import { ButtonGroup, Drawer } from '@common/components';
import { AvailableEnumsKeys } from '@common/graphql';
import { RejectionDrawerValues, RejectionForm } from './rejection-form';

type Props = {
  onClose: () => void;
  onRejectClick: (values: RejectionDrawerValues) => void;
  title: string;
  visible: boolean;
  reasonsListQuery: AvailableEnumsKeys;
  loading?: boolean;
};

export function RejectionDrawer({
  onClose,
  onRejectClick,
  title,
  visible,
  reasonsListQuery,
  loading = false,
}: Props) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!visible) {
      form.resetFields();
    }
  }, [visible, form]);

  return (
    <Drawer
      className="RejectionDrawer"
      open={visible}
      title={title}
      onClose={onClose}
      footer={
        <ButtonGroup>
          <Button size="large" onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button
            danger
            size="large"
            type="primary"
            onClick={form.submit}
            loading={loading}
          >
            Reject
          </Button>
        </ButtonGroup>
      }
    >
      <RejectionForm
        form={form}
        onRejectClick={onRejectClick}
        reasonsListQuery={reasonsListQuery}
      />
    </Drawer>
  );
}
